import React, { useState, useEffect, useRef } from 'react'
import './UsersChatList.css'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Badge, ToastContainer, Toast, Button, Modal } from 'react-bootstrap'
import config from '../../../config'
import { connect } from 'react-redux'
import { getSender, getSenderPic } from '../../../ChatLogics'
import moment from 'moment'
// import NotificationBadge from 'react-notification-badge'
// import { Effect } from 'react-notification-badge'
import {
  setSelectedChat,
  setNotification,
  setUnreadChatsCount,
  setChatList
} from '../../../features/data/dataSlice'
import { Camera, MessageSquarePlus, Phone, Video } from 'lucide-react'
import {
  FileEarmarkFill,
  FileImage,
  FilePdf,
  FileText,
  FiletypeDoc,
  FiletypeXlsx,
  Mic,
  Sticky
} from 'react-bootstrap-icons'
import ProfilePreview from './ProfilePreview'
import CustomNotificationBadge from './CustomNotificationBadge'

function UsersChatsList({
  authToken,
  userInfo,
  fetchAgain,
  setSelectedChat,
  setNotification,
  selectedChat,
  notification,
  setUnreadChatsCount,
  socketConnected,
  setChatList,
  chatList
}) {
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState('')
  const [loggedUser, setLoggedUser] = useState()
  const isDarkMode = document.body.classList.contains('dark-mode-active')
  const handleSearch = event => {
    setSearchTerm(event.target.value)
  }
  const [data, setData] = useState([]) // State to store the data
  const [loading, setLoading] = useState(true) // State to handle loading
  const [error, setError] = useState(null) // State to handle errors

  // toastMessage handler state
  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState('')

  const [isDark, setIsDark] = useState(
    document.body.classList.contains('dark-mode-active')
  )

  // Badges handle
  const [activeBadge, setActiveBadge] = useState('All')
  const badges = ['All', 'Unread', 'Favorites', 'Groups']
  // /badges handle over

  useEffect(() => {
    setLoggedUser(JSON.parse(localStorage.getItem('userInfo')))
    const fetchData = async () => {
      try {
        setLoading(true)
        const head = {
          headers: {
            Authorization: `Bearer ${authToken}`
          }
        }
        const response = await axios.get(`${config.devapi}chat`, head)

        setChatList(response.data)
        setData(response.data)

        // Sync notifications with fetched chats
        const validChatIds = new Set(response.data.map(chat => chat._id))
        const updatedNotifications = notification.filter(notif =>
          validChatIds.has(notif.chat._id)
        )
        setNotification(updatedNotifications)
      } catch (err) {
        setError(err)
        displayToast('Failed to load chat list')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [fetchAgain, authToken, setChatList])
  // console.log('list Data', data)
  // if (loading) return <div>Loading...</div>
  // if (error) return <div>Error: {error.message}</div>

  //  toast message handler
  const displayToast = message => {
    setToastMessage(message)
    setShowToast(true)
    // Auto hide toast after 5 seconds
    setTimeout(() => setShowToast(false), 5000)
  }

  const sortedChats = [...data]
    .filter(chat => {
      // search + badge filtering
      const matchesSearch = searchTerm
        ? (chat.isGroupChat &&
            chat.chatName.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (!chat.isGroupChat &&
            chat.users.some(user =>
              user.name.toLowerCase().includes(searchTerm.toLowerCase())
            ))
        : true

      const matchesBadge =
        activeBadge === 'All'
          ? true
          : activeBadge === 'Unread'
          ? notification.some(notif => notif.chat._id === chat._id)
          : activeBadge === 'Groups'
          ? chat.isGroupChat
          : activeBadge === 'Favorites'
          ? false
          : true

      return matchesSearch && matchesBadge
    })
    .sort((a, b) => {
      const aTime = a.latestMessage?.createdAt || a.updatedAt || '0'
      const bTime = b.latestMessage?.createdAt || b.updatedAt || '0'
      return new Date(bTime) - new Date(aTime)
    })

  // console.log(filteredContacts)

  // console.log(notification)

  // notification in footer
  useEffect(() => {
    const unreadChatIds = new Set(
      notification
        .filter(notif => notif.chat._id !== selectedChat?._id) // Exclude open chat
        .map(notif => notif.chat._id) // Get unique chat IDs
    )

    setUnreadChatsCount(unreadChatIds.size) // Store count of unique unread chats
  }, [notification, selectedChat, setUnreadChatsCount])

  useEffect(() => {
    if (chatList) {
      setData(chatList)
    }
  }, [chatList])

  // const user = JSON.parse(localStorage.getItem('userInfo'))
  // const handleClick = () => {
  //   // Filter out notifications related to the clicked chat
  //   setNotification(notification.filter(notif => notif.chat._id !== chat._id))
  // }

  // useEffect(() => {
  //   const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  //   if (userInfo) {
  //     setLoggedUser(userInfo)
  //   }
  // }, [])

  // const [show, setShow] = useState(false)
  // const handleClose = () => setShow(false)
  // const handleShow = () => setShow(true)
  // const iframeRef = useRef(null)
  // const [receivedMessage, setReceivedMessage] = useState('Waiting...')

  // // Send message to iframe
  // const sendMessageToIframe = () => {
  //   const payload = { message: 'Hello from 1st Up!' }
  //   console.log('Sent to iframe:', payload)
  //   if (iframeRef.current && iframeRef.current.contentWindow) {
  //     iframeRef.current.contentWindow.postMessage(payload, '*')
  //   }
  // }

  // // Receive message from iframe
  // useEffect(() => {
  //   const handleFrameMessage = event => {
  //     console.log('Received from iframe:', event.data)
  //     setReceivedMessage(JSON.stringify(event.data.message))
  //   }

  //   window.addEventListener('message', handleFrameMessage)
  //   return () => window.removeEventListener('message', handleFrameMessage)
  // }, [])

  return (
    <>
      {/* toastMessage */}
      <ToastContainer
        className="p-3 w-75 toast-user"
        // position="middle-center"
        // style={{ zIndex: 10 }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          bg="danger"
          delay={5000}
          autohide
        >
          <Toast.Header closeButton>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <div className="parent-head d-flex justify-content-between align-items-center px-2 py-1">
        <div className="head-left">
          <Link to="/myprofile" class="headerButton">
            <div
              style={{
                border: socketConnected
                  ? '2px solid #34c759'
                  : '2px solid #ec4433',
                borderRadius: '50%'
              }}
            >
              {loggedUser && (
                <img
                  src={loggedUser.pic}
                  alt="avatar"
                  class="imaged rounded"
                  width={36}
                />
              )}
            </div>
          </Link>
        </div>
        <div className="head-center">
          <h2 className="m-0 Title-head">
            1<sup>st</sup>Up
            {/* 1stUp */}
          </h2>
        </div>
        <div
          className="head-right d-flex gap-2 align-items-center"
          onClick={() => window.connectWebSocket && window.connectWebSocket()}
        >
          {/* <div class="chip chip-outline chip-dark">
            <span
              className={`badge badge-empty position-static ms-1 badge-${socketConnected ? 'success' : 'danger'
                }`}
            ></span>
            <span class="chip-label">
              {socketConnected ? 'Online' : 'Offline'}
            </span>
          </div> */}
          <div className=" d-block d-md-none">
            <Camera size={30} strokeWidth={1} />
          </div>
          {/* <div className=" d-block d-md-block">
            <Link to="/contacts" class="item" style={{ color: '#000' }}>
              <MessageSquarePlus size={30} strokeWidth={1} />
            </Link>

            <Button variant="outline-primary" onClick={handleShow}>
              iframe Modal
            </Button>

            <Modal fullscreen show={show} onHide={handleClose}>
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body>
                <iframe
                  ref={iframeRef}
                  src="https://skyq.tech/Demo.html"
                  title="Child Iframe"
                  width="100%"
                  height="750"
                  style={{ border: '1px solid #ccc' }}
                />
                <Button className="mt-3" onClick={sendMessageToIframe}>
                  Send Message to Iframe
                </Button>
                <p className="mt-3">
                  Received from iframe: <strong>{receivedMessage}</strong>
                </p>
              </Modal.Body>
             
            </Modal>
          </div> */}
        </div>
      </div>
      <div className="UsersChatsListView">
        <div
          className="position-sticky searchsec"
          style={{
            top: '0px',
            left: '0',
            right: '0',
            backgroundColor: '#ffffff',
            zIndex: '1'
          }}
        >
          <div className="wide-block pt-1 pb-1 position-sticky searchSection">
            <form className="search-form">
              <div className="form-group searchbox not-empty">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Conversations"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <i className="input-icon">
                  <ion-icon
                    name="search-outline"
                    role="img"
                    className="md hydrated"
                    aria-label="search outline"
                    style={{ marginRight: '12px' }}
                  ></ion-icon>
                </i>
              </div>
            </form>
          </div>
          {/* Badge Filters */}
          <div className="convo-badges mx-2 pb-1 d-flex gap-1">
            {badges.map(badge => (
              <Badge
                key={badge}
                bg={activeBadge === badge ? 'success' : 'primary'}
                className="mx-1 px-2"
                style={{
                  cursor: 'pointer',
                  height: '32px',
                  minWidth: '38px',
                  fontSize: '13px'
                }}
                onClick={() => setActiveBadge(badge)}
              >
                {badge}
              </Badge>
            ))}
          </div>
        </div>
        <ul className="listview image-listview position-relative">
          {sortedChats.map(chat => (
            <li key={chat._id}>
              <div className="item active">
                <div className="position-relative">
                  {chat.isGroupChat === true ? (
                    <>
                      <div
                        className="image d-flex align-items-center justify-content-center col-dry user-pic"
                        style={{ backgroundColor: '#e0e0e0' }}
                        data-bs-toggle="modal"
                        data-bs-target="#DialogImage1"
                      >
                        <ion-icon
                          name="people-sharp"
                          style={{
                            width: '28px',
                            height: '30px'
                          }}
                        ></ion-icon>
                      </div>
                      <div className="type-img">
                        <div className="type-img-icon">
                          <ion-icon
                            name="people-sharp"
                            style={{ color: '#fff' }}
                          ></ion-icon>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* <div class="section full mt-2 mb-2">
                        <div class="section-title">Image Dialog</div>
                        <div class="wide-block pt-2 pb-2">
                          <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-toggle="modal"
                            data-bs-target="#DialogImage"
                          >
                            Show
                          </button>
                        </div>
                      </div> */}
                      {chat.users.some(v => v.type === 'bot') ? (
                        <div
                          className="image d-flex align-items-center justify-content-center col-dry user-pic"
                          style={{ backgroundColor: '#e0e0e0' }}
                          data-bs-toggle="modal"
                          data-bs-target="#DialogImage2"
                        >
                          <ion-icon
                            name="logo-ionitron"
                            style={{ width: '26px', height: '38px' }}
                          ></ion-icon>
                          <div className="type-img">
                            <div className="type-img-icon">
                              <ion-icon
                                name="logo-ionitron"
                                style={{
                                  width: '11px',
                                  height: '11px',
                                  color: '#fff'
                                }}
                              ></ion-icon>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div
                            className="image d-flex align-items-center justify-content-center col-dry user-pic"
                            style={{ backgroundColor: '#e0e0e0' }}
                            data-bs-toggle="modal"
                            data-bs-target="#DialogImage3"
                          >
                            <img
                              src={getSenderPic(loggedUser, chat.users)}
                              alt="avatar"
                              class="imaged rounded"
                              onError={e => {
                                e.target.onerror = null // Prevent infinite loop
                                e.target.src =
                                  'https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg' // Fallback image
                              }}
                              style={{
                                width: '42px',
                                height: '42px',
                                borderRadius: '50%',
                                objectFit: 'cover'
                              }}
                            />
                            {/* // } */}
                            {/* // <ion-icon
                          //   name="person-sharp"
                          //   style={{ width: '26px', height: '38px' }}
                          // ></ion-icon> */}
                            <div className="type-img">
                              <div className="type-img-icon">
                                <ion-icon
                                  name="person-sharp"
                                  style={{
                                    width: '11px',
                                    height: '11px',
                                    color: '#fff'
                                  }}
                                ></ion-icon>
                              </div>
                            </div>
                          </div>
                          <ProfilePreview
                            getSenderPic={getSenderPic}
                            loggedUser={loggedUser}
                            chat={chat}
                          />
                        </>
                      )}
                    </>
                  )}
                </div>
                <Link
                  to={`?chatId=${chat._id}`}
                  className="item ps-0"
                  onClick={() => {
                    setSelectedChat(chat)
                    // Clear notifications for this chat
                    const updatedNotifications = notification.filter(
                      notif => notif.chat._id !== chat._id
                    )
                    setNotification(updatedNotifications)
                  }}
                >
                  {/* {console.log(chat)} */}
                  <div className="d-flex flex-column position-relative w-100">
                    <b
                      style={{
                        textTransform: 'capitalize',
                        fontSize: '15.5px',
                        maxWidth: 'fit-content'
                      }}
                    >
                      {!chat.isGroupChat
                        ? getSender(loggedUser, chat.users)
                        : chat.chatName}
                    </b>
                    {chat?.latestMessage && (
                      <>
                        <div className="d-flex flex-row justify-content-between">
                          <span className="timeAgo ms-0">
                            <strong>
                              {(() => {
                                const senderId =
                                  chat?.latestMessage?.sender?._id
                                const senderUser = chat?.users?.find(
                                  u => u._id === senderId
                                )

                                if (!senderUser) return 'Unknown'

                                if (senderUser.type === 'bot') {
                                  return (
                                    senderUser.display ||
                                    senderUser.name ||
                                    'Bot'
                                  )
                                } else {
                                  return senderUser.name
                                }
                              })()}{' '}
                              : &nbsp;
                            </strong>

                            {chat.latestMessage.type === 'sticker' ? (
                              <span className="align-items-center">
                                <Sticky
                                  size={13}
                                  style={{
                                    marginRight: '4px',
                                    marginBottom: '3px'
                                  }}
                                />
                                Sticker
                              </span>
                            ) : chat?.latestMessage?.type === 'location' ? (
                              <span className="align-items-center">
                                <ion-icon
                                  name="location-outline"
                                  style={{
                                    marginRight: '4px',
                                    width: '12px',
                                    height: '12px'
                                  }}
                                ></ion-icon>
                                Live Location
                              </span>
                            ) : chat?.latestMessage?.type === 'call' ? (
                              <>
                                {chat?.latestMessage?.callType === 'Audio' ? (
                                  <>
                                    <Phone size={13} /> Voice call
                                  </>
                                ) : chat?.latestMessage?.callType ===
                                  'Video' ? (
                                  <>
                                    <Video size={13} /> Video call
                                  </>
                                ) : (
                                  'Missed Call'
                                )}
                              </>
                            ) : chat?.latestMessage?.type === 'audio' ? (
                              <span className="align-items-center">
                                <Mic size={13} style={{ marginRight: 4 }} />
                                Audio msg
                              </span>
                            ) : chat?.latestMessage.type === 'file' ? (
                              () => {
                                const isImage =
                                  chat.latestMessage.content?.match(
                                    /\.(png|jpg|jpeg|gif|svg|webp)$/i
                                  )
                                const isPdf =
                                  chat.latestMessage.content?.match(/\.pdf$/i)
                                const isDoc =
                                  chat.latestMessage.content?.match(
                                    /\.(doc|docx)$/i
                                  )
                                const isExcel =
                                  chat.latestMessage.content?.match(
                                    /\.(xls|xlsx)$/i
                                  )
                                const isText =
                                  chat.latestMessage.content?.match(/\.txt$/i)

                                return (
                                  <span className="align-items-center">
                                    {isImage ? (
                                      <FileImage
                                        size={13}
                                        style={{
                                          marginRight: '4px',
                                          marginBottom: '3px'
                                        }}
                                      />
                                    ) : isPdf ? (
                                      <FilePdf
                                        size={13}
                                        style={{
                                          marginRight: '4px',
                                          marginBottom: '3px'
                                        }}
                                      />
                                    ) : isDoc ? (
                                      <FiletypeDoc
                                        size={13}
                                        style={{
                                          marginRight: '4px',
                                          marginBottom: '3px'
                                        }}
                                      />
                                    ) : isExcel ? (
                                      <FiletypeXlsx
                                        size={13}
                                        style={{
                                          marginRight: '4px',
                                          marginBottom: '3px'
                                        }}
                                      />
                                    ) : isText ? (
                                      <FileText
                                        size={13}
                                        style={{
                                          marginRight: '4px',
                                          marginBottom: '3px'
                                        }}
                                      />
                                    ) : (
                                      <FileEarmarkFill
                                        size={13}
                                        style={{
                                          marginRight: '4px',
                                          marginBottom: '3px'
                                        }}
                                      />
                                    )}
                                    File msg
                                  </span>
                                )
                              }
                            ) : chat?.latestMessage?.type === 'call' ? (
                              <>
                                {chat?.latestMessage?.callType === 'Audio' ? (
                                  <>
                                    <Phone size={13} /> &nbsp;Audio call
                                  </>
                                ) : chat?.latestMessage?.callType ===
                                  'Video' ? (
                                  <>
                                    <Video size={13} /> &nbsp;Video call
                                  </>
                                ) : (
                                  'Missed Call'
                                )}
                              </>
                            ) : chat.latestMessage.content.length > 25 ? (
                              <span className="msg-content">
                                {chat.latestMessage.content.substring(0, 26) +
                                  '...'}
                              </span>
                            ) : (
                              <span>{chat.latestMessage.content}</span>
                            )}
                          </span>
                          <span
                            className="time"
                            style={{
                              fontSize: '12px',
                              position: 'relative',
                              top: '-1.3rem',
                              height: 'fit-content',
                              right: '-1.5rem',
                              display: 'flex',
                              flexWrap: 'nowrap'
                            }}
                          >
                            {chat.latestMessage.createdAt
                              ? moment(chat.latestMessage.createdAt).calendar(
                                  null,
                                  {
                                    sameDay: 'hh:mm A', // Shows time if message is from today
                                    lastDay: '[Yesterday]', // Shows "Yesterday" if message was from yesterday
                                    lastWeek: 'DD/MM/YY', // Shows date if message was sent before yesterday
                                    sameElse: 'DD/MM/YY' // Fallback date format
                                  }
                                )
                              : 'N/A'}
                          </span>
                        </div>
                      </>
                    )}
                    {/* Notification badge */}
                    <div className="notify">
                      {notification.some(
                        notif =>
                          notif.chat._id === chat._id &&
                          selectedChat?._id !== chat._id
                      ) && (
                        <div>
                          <CustomNotificationBadge
                            style={{
                              top:
                                chat.latestMessage.content.length > 20
                                  ? '-2px'
                                  : '8.5px',
                              right: '-10px',
                              width: 'fit-content',
                              height: 'fit-content'
                            }}
                            count={
                              notification.filter(
                                notif =>
                                  notif.chat._id === chat._id &&
                                  selectedChat?._id !== chat._id
                              ).length
                            }
                            isDark={isDark}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            </li>
          ))}
        </ul>
        <div class="fab-button bottom-right dropdown rounded-circle fab-ton d-block d-md-none">
          <Link to="/contacts" class="item">
            <a
              href="#"
              class="fab"
              style={{ backgroundColor: `${isDarkMode ? '#fff' : '#272626'}` }}
            >
              <ion-icon
                name="add-outline"
                class="md hydrated h1 pt-1"
                style={{
                  color: `${isDarkMode ? '#000' : '#fff'}`
                }}
              ></ion-icon>
            </a>
          </Link>
        </div>
      </div>
      {/* {filteredContacts.map(chat => (
        <>
          {chat.isGroupChat === true ? (
            <div
              class="modal fade dialogbox"
              id="DialogImage"
              // data-bs-backdrop="static"
              tabindex="-1"
              role="dialog"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <img
                    // src="assets/img/sample/photo/1.jpg"
                    src={getSenderPic(loggedUser, chat.users)}
                    alt="image"
                    class="img-fluid"
                  />
                  <div class="modal-footer">
                    <div class="btn-inline">
                      <a
                        href="#"
                        class="btn btn-text-secondary"
                        data-bs-dismiss="modal"
                      >
                        CLOSE
                      </a>
                      <a
                        href="#"
                        class="btn btn-text-primary"
                        data-bs-dismiss="modal"
                      >
                        SHARE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {chat.users.some(v => v.type === 'bot') ? (
                <div
                  class="modal fade dialogbox"
                  id="DialogImage"
                  // data-bs-backdrop="static"
                  tabindex="-1"
                  role="dialog"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <img
                        // src="assets/img/sample/photo/1.jpg"
                        src={getSenderPic(loggedUser, chat.users)}
                        alt="image"
                        class="img-fluid"
                      />
                      <div class="modal-footer">
                        <div class="btn-inline">
                          <a
                            href="#"
                            class="btn btn-text-secondary"
                            data-bs-dismiss="modal"
                          >
                            CLOSE
                          </a>
                          <a
                            href="#"
                            class="btn btn-text-primary"
                            data-bs-dismiss="modal"
                          >
                            SHARE
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  class="modal fade dialogbox"
                  id="DialogImage"
                  // data-bs-backdrop="static"
                  tabindex="-1"
                  role="dialog"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <img
                        // src="assets/img/sample/photo/1.jpg"
                        src={getSenderPic(loggedUser, chat.users)}
                        alt="image"
                        class="img-fluid"
                      />
                      <div class="modal-footer">
                        <div class="btn-inline">
                          <a
                            href="#"
                            class="btn btn-text-secondary"
                            data-bs-dismiss="modal"
                          >
                            CLOSE
                          </a>
                          <a
                            href="#"
                            class="btn btn-text-primary"
                            data-bs-dismiss="modal"
                          >
                            SHARE
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <div
            class="modal fade dialogbox"
            id="DialogImage"
            // data-bs-backdrop="static"
            tabindex="-1"
            role="dialog"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <img
                  // src="assets/img/sample/photo/1.jpg"
                  src={getSenderPic(loggedUser, chat.users)}
                  alt="image"
                  class="img-fluid"
                />
                <div class="modal-footer">
                  <div class="btn-inline">
                    <a
                      href="#"
                      class="btn btn-text-secondary"
                      data-bs-dismiss="modal"
                    >
                      CLOSE
                    </a>
                    <a
                      href="#"
                      class="btn btn-text-primary"
                      data-bs-dismiss="modal"
                    >
                      SHARE
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ))} */}
    </>
  )
}

const mapStateToProps = ({ auth, data }) => {
  const { authToken, userInfo } = auth
  const { selectedChat, notification, socketConnected, chatList } = data
  return {
    authToken,
    userInfo,
    selectedChat,
    notification,
    socketConnected,
    chatList
  }
}

const mapDispatchToProps = {
  setSelectedChat,
  setNotification,
  setUnreadChatsCount,
  setChatList
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersChatsList)
